import { render, staticRenderFns } from "./ProductServiceMicrosite.vue?vue&type=template&id=dc2bcd2c&scoped=true"
import script from "./ProductServiceMicrosite.vue?vue&type=script&lang=js"
export * from "./ProductServiceMicrosite.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceMicrosite.vue?vue&type=style&index=0&id=dc2bcd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2bcd2c",
  null
  
)

export default component.exports